// extracted by mini-css-extract-plugin
export default {"body":"Motd_body__rTDYl"};